// extracted by mini-css-extract-plugin
export default {"root":"SignUpForm_root__-mp6s","inputLink":"SignUpForm_inputLink__GwEgI","after":"SignUpForm_after__dPON2","eyeIcon":"SignUpForm_eyeIcon__62KRL"};